import React, { useState } from "react";
import { Button,  Modal  } from "../../../../../../components";
// import { keyToTitle } from "../../../../../../utils";

const Info = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div>
      <div className="flex gap-2 items-center">
        <h6 className="my-2">Job Description</h6>
        <Button
          type="icon"
          color="black"
          variant="text"
          icon={"info"}
          onClick={() => setIsModalOpen(true)}
        />
      </div>
      <p className="text-sm text-gray-400 font-[400]">
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Non quam,
        perferendis numquam maiores velit suscipit eius sunt cumque ex cum. Amet
        optio veniam eligendi ullam quos. Modi, quaerat possimus animi corporis,
        quasi assumenda perspiciatis repellendus quam error fugiat, ut
        cupiditate nostrum? Qui fugit tempore pariatur perferendis quos maxime
        sequi ratione amet quia quo. Nisi odit doloremque molestiae sed ipsa
        esse.
      </p>

      <Modal
        isOpen={isModalOpen}
        title={"Job Description"}
        onClose={() => setIsModalOpen(false)}
        width="max-w-3xl"
      >
        <div
          className="h-100"
          // dangerouslySetInnerHTML={{
          //   __html: cleanHtml(
          //     jobDetails?.orgInform?.jobDescription || ""
          //   )
          // }}
        >
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt unde
          vel tempore pariatur quasi adipisci at ad eius ea eligendi.
        </div>
      </Modal>
    </div>
  );
};

export default Info;
